import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { BreadCrumb } from 'src/app/models/breadcrumb.model';
import { HeaderButton } from 'src/app/models/headerbtn.model';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SchoolModuleEvent,
  lessondetails,
  lessonnote,
} from 'src/app/models/module/moduledetails';
import { AdminAction } from 'src/app/models/adminaction.model';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { UtilService } from 'src/app/services/util.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { QuestionDisplay } from 'src/app/models/assessment/newquestion.model';
import { AssessmentAnswerSubmissionModel } from 'src/app/models/assessment/assessmentsubmission.model';
import { HTMLEntities } from 'src/app/models/HTMLEntities';
import { GameAttemptResult, LessonGamePlay, LessonPageBlock } from 'src/app/models/module/lessongame.model';
import { OfflineSaveService } from 'src/app/services/offline/offline-save.service';
import { OfflineSessionService } from 'src/app/services/offline/offline-session.service';
import { OfflineEntitlementService } from 'src/app/services/offline/offline-entitlement.service';
import { OfflineDbService } from 'src/app/services/offline/offline-db.service';
import { OfflineConnectivityService } from 'src/app/services/offline/offline-connectivity.service';
import { canSaveForOffline } from 'src/app/services/offline/offline-feature-gate';
import { buildIndexKey, getCurrentSchoolSubdomain, getCurrentUserId } from 'src/app/services/offline/offline-cache-key';
import { FullscreenNoteChrome } from 'src/app/services/fullscreen-note-chrome';


declare var $: any;

@Component({
  selector: 'app-classdetails',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css'],
})
export class DetailsComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  private questionTimeout: any;
  showlessonfileupload: boolean = false;
  lesson: lessondetails = new lessondetails();
  confirmLessonDelete: boolean = false;
  notehtml: SafeHtml = '';
  prevlesson: any;
  nextlesson: any;
  breadcrumb: BreadCrumb[];
  headerbtn: HeaderButton[];
  //currentuser: any;
  moduleid: number = 0;
  classid: number = 0;
  fetchingdata: boolean;
  adminActions: AdminAction[] = [];
  classfiles: any;
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;
  hasemptytag: boolean = false;
  enableNextLesson: boolean = false;
  classFileName: string;
  toursteps: any[] = [];
  isClassCompleted: boolean = false;
  // Offline mode P3 — mirrors the "Mark Completed" button's own conditional/visual tier.
  offlineSaveEligible = false;
  savedOffline = false;
  savingOffline = false;
  // Per-lesson video quality picker — only populated/shown when saveOfflineClicked() finds a
  // In-class quizzes live inside this same /user/lesson route (not a separate route
  // OfflineBlockAssessmentGuard can guard), so a connectivity drop mid-quiz needs its own
  // check here rather than app.component.ts's URL-based assessmentOfflineBlocked.
  get quizBlockedOffline(): boolean {
    return this.showInclassAssessement && this.offlineConnectivity.currentState !== 'online';
  }
  schoolModuleEvent: Array<SchoolModuleEvent> = [];
  displayEvents: Array<SchoolModuleEvent> = [];
  lessonnote: Array<lessonnote> = [];
  games: LessonGamePlay[] = [];
  blocks: LessonPageBlock[] = [];
  currentBlock: LessonPageBlock = null;
  /* Full-screen reading mode for the note pane. Behaviour lives in the shared helper so
     the offline reader and the note editor behave identically. */
  readonly fs = new FullscreenNoteChrome();
  currentPage: number;
  batchid = 0;
  showInclassAssessement = false;
  questions: any[];
  assessment: any;
  @ViewChild("questionPane") questionPane: ElementRef;
  @ViewChild("buttonPane") buttonPane: ElementRef;
  hideQuestionNavButton: number;
  showsubmit: boolean;
  questionInView: QuestionDisplay = new QuestionDisplay();
  questionCount: number;
  submitinProgress: boolean;
  showRetake: boolean;
  quizCompleted = false;
  isScored: boolean;
  // score = 0;
  failedQuizzes: any;
  failedMessage = "";
  textToRead: string;
  textarea: any;
  textReaderReady: boolean;
  hasMedia: boolean;
  @ViewChild('lessonnotearea') lessondiv: ElementRef;
  //eventsFeatureAvailable = false;
  constructor(
    public headerinfo: ComponentheaderService,
    private classmanager: ClassmanagementService,
    private modulemanager: ModulemanagementService,
    public userservice: UseraccessserviceService,
    private router: ActivatedRoute,
    private route: Router,
    private activatedroute: ActivatedRoute,
    private toastr: ToastrService,
    public sanitizer: DomSanitizer,
    public util: UtilService,
    public schoolservice: SchoolmanagementService,
    public assessmentManager: AssessmentmanagerService, private renderer: Renderer2, private elementRef: ElementRef, private cdr: ChangeDetectorRef,
    private offlineSave: OfflineSaveService, private offlineSession: OfflineSessionService, private offlineEntitlement: OfflineEntitlementService,
    private offlineDb: OfflineDbService, public offlineConnectivity: OfflineConnectivityService
  ) {
    headerinfo.setHeaderDisplay('Loading Lesson...', [], []);
    // setTimeout(async () => {
    //   await classmanager.createlog(this.classid).toPromise()
    // }, 120000);
    //this.currentuser = this.userservice.currentUser.id;
    this.toursteps = [
      {
        intro: ' Lesson Note is displayed Here',
        position: 'right',
      },
    ];
  }
  ngAfterViewChecked(): void {
    this.textarea = this.lessondiv?.nativeElement;
    this.showTextReady();
    this.cdr.detectChanges();
  }
  async ngAfterViewInit() {
    await this.classmanager.logLessonView(this.moduleid, this.classid).toPromise();
  }
  async ngOnInit() {
    //debugger;
    //let schooldetails: any = await this.schoolservice.getSchoolDetails().toPromise();
    this.setLesson();

    // There was a subscription to Router.events here whose body was entirely commented
    // out — it did nothing, was never unsubscribed, and since Router.events lives for the
    // life of the application, every lesson opened left another subscriber behind.
    // Students move lesson to lesson, so it accumulated faster than anywhere else.

    // Namespaced so it can be removed again. This binds to *every* modal in the
    // application, and without the matching .off() a fresh handler was added each time a
    // lesson was opened.
    $('.modal').on('click.lessondetails', function () {
      $('#deleteLesson').modal('hide');
    });
  }

  ngOnDestroy(): void {
    $('.modal').off('click.lessondetails');
    if (this.questionTimeout) {
      clearTimeout(this.questionTimeout);
    }
    // The scroll lock the helper sets lives on <body>, which outlives this component.
    // Leaving it set froze the page after navigating away.
    this.fs.destroy();
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    if (this.fs.active) {
      this.fs.set(false);
    }
  }

  setLesson() {
    this.router.queryParams.subscribe((routeParams) => {
      window.scrollTo(0, 0);
      if (routeParams.classid > 0) {
        this.classid = routeParams.classid;
      }
      if (routeParams.moduleid > 0) {
        this.moduleid = routeParams.moduleid;
      }
      this.getLesson(this.moduleid, this.classid);
    });
  }

  buildBlocks(): void {
    const noteBlocks: LessonPageBlock[] = this.lessonnote.map(n => {
      const b = new LessonPageBlock();
      b.page = n.page || 0;
      b.kind = 'note';
      b.note = n;
      b.attempted = true; // notes never gate progress
      return b;
    });
    const gameBlocks: LessonPageBlock[] = this.games.map(g => {
      const b = new LessonPageBlock();
      b.page = g.page || 0;
      b.kind = 'game';
      b.game = g;
      b.attempted = false;
      return b;
    });
    this.blocks = [...noteBlocks, ...gameBlocks].sort((a, b) => {
      if (a.page !== b.page) return a.page - b.page;
      // a game takes precedence over a note on the same page — the note shifts back
      if (a.kind === b.kind) return 0;
      return a.kind === 'game' ? -1 : 1;
    });
  }

  loadNotes(page: number = 1) {
    this.currentBlock = this.blocks[page - 1] || null;
    this.currentPage = page;

    // Full-screen mode follows the reader across both note and game pages — both kinds
    // render a card that fs-surface can take over, so there is no page it needs to exit
    // on. If a third block kind is ever added without a fs-surface card, it will need to
    // exit here too.

    if (this.currentBlock?.kind === 'note' && this.currentBlock.note?.content) {
      this.notehtml = this.sanitizer.bypassSecurityTrustHtml(this.currentBlock.note.safeContent);
      this.textToRead = this.currentBlock.note.safeContent;
      this.hasemptytag = this.currentBlock.note.safeContent == '<p><br></p>';
    }
    else {
      this.notehtml = "";
      this.textToRead = "";
    }
  }

  onGameAttempted(block: LessonPageBlock, result: GameAttemptResult): void {
    block.attempted = true;
  }
  async getLesson(moduleid: number, classid: number) {
    //debugger;
    this.headerinfo.pageLoadingStarted(this);
    this.fetchingdata = true;

    try {
      const data = await this.classmanager.getClassDetails(classid).toPromise();

      this.lesson = data;
      this.lessonnote = data.note;
      this.batchid = data.batchid;

      if (this.lessonnote.length == 0) {
        this.lessonnote[0] = new lessonnote();
        this.lessonnote[0].schoolModuleClassID = classid;
      }

      try {
        this.games = await this.classmanager.getLessonGames(classid).toPromise();
      } catch (error) {
        this.games = [];
      }
      this.buildBlocks();
      this.loadNotes(1);

      if (!await this.util.hasFeature(FeatureGroups.ASSESSMENTS)) {
        this.lesson.assessments = 0;
      }
      else {
        this.lesson.assessments = data.assessments;
      }

      this.moduleid = this.lesson.moduleid;
      this.isClassCompleted = data.completed;
      this.initOfflineSaveEligibility(classid);

      if (!await this.util.hasFeature(FeatureGroups.EVENTS)) {
        this.schoolModuleEvent = [];
      }
      else {
        this.schoolModuleEvent = await this.modulemanager
          .getUpcomingModuleInvites(this.moduleid, classid);
      }
      //debugger;
      this.fetchingdata = false;
      if (this.lesson.adminuser) {
        this.adminActions = [
          {
            displaytext: 'Edit Notes / Videos',
            route: '/user/lessonnote',
            params: { classid: this.classid },
            classes: ['fas', 'fa-indent'],
          },
          {
            displaytext: 'Edit Lesson',
            route: '/user/editlesson',
            params: { classid: this.classid },
            classes: ['fa', 'fa-edit'],
          },
          {
            displaytext: 'Manage Games',
            route: '/user/lessongameeditor',
            params: { classid: this.classid },
            classes: ['fas', 'fa-puzzle-piece'],
          },
          {
            displaytext: 'Media Library',
            route: '/user/modulemedialibrary',
            params: { moduleid: this.lesson.moduleid, classid: this.classid },
            classes: ['fas', 'fa-photo-video'],
            disabled: !await this.util.hasFeature(FeatureGroups.MEDIA_LIBRARY),
            featureGroup: FeatureGroups.MEDIA_LIBRARY
          },
          // { displaytext: 'Edit Lesson Description', route: '/user/lessonnote', params: { moduleID: this.moduleid, classid: this.classid } },
          {
            displaytext: 'Delete All Notes / Videos',
            callback: this.popconfirmdeletenote.bind(this),
            classes: ['fas', 'fa-trash'],
          },
          {
            displaytext: 'Delete Lesson',
            callback: this.popconfirmdelete.bind(this),
            classes: ['fas', 'fa-trash'],
          },
          {
            displaytext: 'Manage Assessments',
            route: '/user/assessmentconsole',
            params: { classid: this.classid, batchid: 0 },
            classes: ['fas', 'fa-tasks'],
            disabled: !await this.util.hasFeature(FeatureGroups.ASSESSMENTS),
            featureGroup: FeatureGroups.ASSESSMENTS
          },
          {
            displaytext: 'Manage Events',
            route: '/events/view',
            params: { moduleID: this.lesson.moduleid, classid: this.classid },
            classes: ['fas', 'fa-calendar'],
            disabled: !(await this.util.hasFeature(FeatureGroups.EVENTS)),
            featureGroup: FeatureGroups.EVENTS,
          }
          // { displaytext: 'Lesson Log', route: '/user/lessonnote', params: { moduleID: this.moduleid, classid: this.classid } },
        ];
      } else {
        this.adminActions = [];
      }
      this.headerinfo.setHeaderDisplay(
        this.lesson.title,
        [
          { displaytext: 'School', route: `/user/schoolhome` },
          {
            displaytext: 'Course',
            route: `/user/moduledetails`,
            params: { moduleID: this.lesson.moduleid },
          },
          {
            displaytext: 'Lesson',
            route: `/user/lesson`,
            params: { classid: classid },
          },
        ],
        this.adminActions,
        this.toursteps
      );

      this.displayEvents = this.schoolModuleEvent.slice(0, 3);
      const prevLessonPromise = this.classmanager
        .getprevlesson(this.classid, this.moduleid)
        .toPromise();
      const nextLessonPromise = this.classmanager
        .getnextlesson(this.classid, this.moduleid)
        .toPromise();
      const classFilesPromise = this.classmanager
        .getclassfiles(classid)
        .toPromise();
      // const liveClassPromise = this.classmanager
      //   .getLiveClassSchedules(this.classid)
      //   .toPromise();

      [
        this.prevlesson,
        this.nextlesson,
        this.classfiles,
        //this.liveclassschedules,
      ] = await Promise.all([
        prevLessonPromise,
        nextLessonPromise,
        classFilesPromise,
        //liveClassPromise,
      ]);

      //console.log(this.classfiles[0]);

      if (this.nextlesson) {
        let currentdate = new Date();
        let lessonPublishedDate = new Date(this.nextlesson.publishdate);
        if (lessonPublishedDate.getTime() < currentdate.getTime()) {
          this.enableNextLesson = true;
        }
      } else {
        this.enableNextLesson = false;
      }

      this.headerinfo.pageLoadingDone(this);

      if (this.lesson.hasInclassAssessement && this.lesson.inclassAssessementID && this.lesson.adminuser){
        this.startQuiz();
      }
    } catch (error) {
      //debugger;
      this.headerinfo.pageLoadingDone(this);
      // this.errorMessage = "Error : " + err.statusText;
      if (this.moduleid == 0) {
        const abridgeddetails = await this.classmanager
          .getClassDetailsAbridged(classid)
          .toPromise();
        this.moduleid = abridgeddetails.moduleid;
      }
      this.route.navigate(['/user/moduledetails'], {
        queryParams: { moduleID: this.moduleid },
      });

      this.fetchingdata = false;
    }
  }

  popconfirmdelete() {
    $('#deleteLesson').modal('show');
  }

  popconfirmdeletenote() {
    $('#deleteLessonnote').modal('show');
  }

  gotoUpcomingEvents() {
    this.route.navigate(['/events/view'], {
      queryParams: { moduleID: this.moduleid, isStudent: 1, classid: this.classid }
    });
  }

  async deleteLesson() {
    $('#deleteLesson').modal('hide');
    await this.classmanager
      .deleteclass(this.classid, this.moduleid)
      .toPromise();
    this.route.navigate(['/user/moduledetails'], {
      queryParams: { moduleID: this.moduleid },
    });
    this.toastr.success('Successfully deleted');
  }

  async deleteLessonnote() {
    $('#deleteLessonnote').modal('hide');
    this.lessonnote.forEach(async l => await this.classmanager
      .deleteclassnote(this.classid, l.id)
      .toPromise())

    //this.route.navigate(['/user/moduledetails'], { queryParams: { moduleID: this.moduleid } });
    this.toastr.success('Lesson Note Successfully Deleted');
    // this.route.navigate(['/user/lesson'], { queryParams: {moduleid: this.moduleid , classid:this.classid} });
    window.location.reload();
  }

  async saveclassfile(files: FileList) {
    // debugger;
    this.showlessonfileupload = false;
    this.classFileName = '';

    let totalfilesize = 0;
    for (let i = 0; i < files.length; i++) {
      totalfilesize += files[i].size;
    }

    const maxSizeInBytes = 10 * 1024 * 1024 * 1024; // 10 GB

    if (totalfilesize > maxSizeInBytes) {
      this.toastr.error('Upload failed. Total file size exceeds 10GB limit.');
      return;
    }

    try {
      this.classfiles = await this.classmanager
        .saveclassfile(this.moduleid, this.classid, files)
        .toPromise();
      this.toastr.success('File uploaded successfully');
    } catch (error) {
      this.toastr.error('File upload failed. Please try again.');
    }


    // this.modulemanager
    //   .getMediaStatus(this.lesson.schoolid, totalfilesize)
    //   .toPromise()
    //   .then(async (response: boolean) => {
    //     if (response) {
    //       this.classfiles = await this.classmanager
    //         .saveclassfile(this.moduleid, this.classid, files)
    //         .toPromise();
    //       this.toastr.success('File Uploaded Successfully');
    //     } else {
    //       this.toastr.error(
    //         'Upload Failed. You Have Exceeded Your Media Storage Limit'
    //       );
    //     }
    //   });
  }
  async deleteclassfile(fileid: any) {
    this.classfiles = await this.classmanager
      .deleteclassfile(this.classid, fileid)
      .toPromise();
    this.toastr.success('File Deleted Successfully');
  }
  togglelessonfileupload(show: number) {
    if (show == 1) {
      this.showlessonfileupload = true;
    } else {
      this.showlessonfileupload = false;
    }
  }

  async nextclicked() {
    //debugger;
    if (
      !this.lesson.adminuser &&
      this.lesson.moduleRequiresLessonCompletion &&
      !this.isClassCompleted
    ) {
      let txt = 'Please Complete this lesson before proceeding'
      txt = this.showInclassAssessement ? "Please Complete this lesson's quiz before proceeding " : txt;
      this.toastr.error(
        txt,
        'Please Complete Lesson'
      );
    } else {
      this.clearQuiz();
      this.route.navigate(['/user/lesson'], {
        queryParams: { classid: this.nextlesson.id, moduleid: this.moduleid },
      });
      await this.classmanager.logLessonView(this.moduleid, this.nextlesson.id).toPromise();
    }
  }

  // Offline mode P3 — never throws; the button simply doesn't render on any failure. Fails
  // closed exactly like OfflineSaveService.saveLesson's own guard does (D5: non-admin only,
  // plus a valid entitlement covering this module).
  private async initOfflineSaveEligibility(classid: number): Promise<void> {
    try {
      if (this.lesson.adminuser) return;
      const schoolToggle = this.offlineSession.current?.offlineEnabled ?? false;
      if (!canSaveForOffline(schoolToggle)) return;

      const entitlement = await this.offlineEntitlement.getValid();
      if (!entitlement || !entitlement.moduleIds.includes(this.moduleid)) return;

      const school = getCurrentSchoolSubdomain();
      const user = getCurrentUserId(this.userservice.getCurrentUserToken());
      if (!school || !user) return;

      this.offlineSaveEligible = true;
      const key = buildIndexKey(school, user, 'lesson', String(classid));
      // Read IndexedDB directly, not OfflineSaveService.savedState$ — that in-memory snapshot
      // is only populated as a side effect of a save/unsave call happening THIS session, so on
      // a fresh page load (or navigating back to an already-saved lesson) it's still the empty
      // default Map and would wrongly report "not saved" even though it genuinely is.
      this.savedOffline = await this.offlineDb.isSaved(key);
    } catch (err) {
      console.error('[offline] save-eligibility check failed', err);
    }
  }

  // Offline saving covers the lesson's NOTES only. Video was deliberately taken out of this
  // path: it brought in a rendition lookup, a quality-picker modal and a per-video download,
  // any of which failing took the note save down with it. One click, notes only.
  async saveOfflineClicked(): Promise<void> {
    if (this.savingOffline || this.savedOffline) return;
    await this.doSaveLesson();
  }

  private async doSaveLesson(): Promise<void> {
    this.savingOffline = true;
    try {
      const result = await this.offlineSave.saveLesson(this.moduleid, this.classid);
      if (result.ok === true) {
        this.savedOffline = true;
        this.toastr.success('Lesson saved for offline use.');
      } else {
        this.toastr.error((result as { ok: false; error: string }).error || 'Could not save this lesson for offline use.');
      }
    } finally {
      this.savingOffline = false;
    }
  }

  async markCompletedclicked() {
    if (!this.isClassCompleted) {

      if (this.lesson.hasInclassAssessement && this.lesson.inclassAssessementID != 0 && !this.quizCompleted) {
        await this.startQuiz();
        return;
      }
      this.headerinfo.pageLoadingStarted(this);

      this.classmanager
        .markLessonCompleted(this.classid)
        .toPromise()
        .then(async (res: any) => {
          this.toastr.success('Lesson completed.');
          this.isClassCompleted = true;
          this.quizCompleted = false;
          if (res.lastLesson) {
            this.route.navigate(['/user/moduledetails'], {
              queryParams: { moduleID: this.moduleid },
            });
            if (res.allClassesCompleted) {
              this.toastr.success(
                'You\'ve completed all the lessons. Use the "Complete Course" button below to complete the course',
                'Congratulations!!!'
              );
            }
          }
          this.headerinfo.pageLoadingDone(this);
        })
        .catch(() => this.headerinfo.pageLoadingDone(this));
    }
  }

  async startQuiz() {
    // In-class quizzes are embedded directly in the lesson page (not a separate route), so
    // OfflineBlockAssessmentGuard never sees this path — same D3 rule (no offline
    // assessments) enforced here directly instead.
    if (this.offlineConnectivity.currentState !== 'online') {
      this.toastr.error('Assessments need an internet connection. Please reconnect and try again.', 'Offline');
      return;
    }
    this.isScored = false;
    this.showRetake = false;
    this.failedMessage = '';
    this.showsubmit = true;
    this.failedQuizzes = [];
    this.headerinfo.pageLoadingStarted(this);
    let response: any = await this.assessmentManager.getAssessmentDetails(this.lesson.inclassAssessementID, this.batchid).toPromise();

    if (!response.data.allAssessmentDone && !this.lesson.adminuser) {
      this.toastr.error("Please take all assessments before completing the lesson")
      this.headerinfo.pageLoadingDone(this)
      return;
    }
    this.assessment = response.data
    this.questions = this.assessment.questions;
    this.questionCount = this.questions.length;
    this.showInclassAssessement = true;

    if (this.assessment.scored) {
      this.headerinfo.pageLoadingDone(this)
      this.retakeAssessment();
    }
    this.headerinfo.pageLoadingDone(this)
    // deferred so the relevant controls exist in the browser first; cleared on destroy
    this.questionTimeout = setTimeout(() => {
      this.getQuestionToShow(0);
    });
  }
  getStatus(item: any) {
    if (new Date(item.inviteStartDate) < new Date() && new Date(item.inviteEndDate) > new Date()) {
      return "Ongoing";
    }
    return "Upcoming"
  }

  canJoinEvents(evet: SchoolModuleEvent) {
    let isLink = this.util.isLink(evet.venue);
    let today = new Date();
    let startEvent = new Date(evet.inviteStartDate);
    startEvent.setMinutes(startEvent.getMinutes() - 5);//reomving 5min from startTime to show join btn early.
    let endEvent = new Date(evet.inviteEndDate);
    if (startEvent <= today && endEvent > today && isLink) {
      return true;
    }
    return false;
  }
  joinEvent(url) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = "_blank"
    anchor.click();
  }

  async nextPage() {
    if (this.currentPage < this.blocks.length) {
      this.currentPage = this.currentPage + 1;
      this.loadNotes(this.currentPage);
    }
    else if (this.blocks.length == this.currentPage && this.enableNextLesson) {
      this.nextclicked();
    }
  }
  async previousPage() {
    if (this.currentPage == 1 && this.prevlesson) {
      this.clearQuiz();
      this.route.navigate(['/user/lesson'], { queryParams: { classid: this.prevlesson.id, moduleid: this.moduleid } })
      await this.classmanager.logLessonView(this.moduleid, this.prevlesson.id).toPromise();
    }
    else {
      this.currentPage = this.currentPage - 1;
      this.loadNotes(this.currentPage);
    }
  }
  async gotoPage(page: number) {
    this.loadNotes(page);
  }

  getQuestionToShow(questionIndex: number) {
    let questionsContainer = this.questionPane.nativeElement as HTMLElement;
    let buttonContainer = this.buttonPane.nativeElement as HTMLElement;

    let allquestion = questionsContainer.getElementsByTagName("li");

    let questionItemNavButtons = buttonContainer.getElementsByClassName("questionBadge");

    let questionListLenght = this.assessment.questions.length;
    //hide nextbutton
    if (questionIndex == questionListLenght || questionIndex == questionListLenght - 1) {
      this.hideQuestionNavButton = 1;
      this.showsubmit = true;
    }
    //hide previus button
    else if (questionIndex <= 0) {
      this.hideQuestionNavButton = 2;
      this.showsubmit = false;
    }
    else {
      this.hideQuestionNavButton = 0;
      this.showsubmit = false;
    }

    if (questionIndex < questionListLenght && questionIndex > -1) {

      Array.from(allquestion).forEach((item, index) => {
        item.classList.add("ghostquestion");
        if (questionItemNavButtons.length > 0) {
          questionItemNavButtons.item(index).classList.remove("questionBadge_active");
        }
      });
      let questionToShow = allquestion.item(questionIndex)
      questionToShow.classList.remove("ghostquestion");

      let questionAtIndex = this.assessment.questions[questionIndex]
      this.questionInView.marks = questionAtIndex.marks;
      this.questionInView.answeredText = questionAtIndex.stdAnswer;
      this.questionInView.index = questionIndex + 1;
      this.questionInView.next = questionIndex + 1;
      this.questionInView.previous = questionIndex - 1;
      this.questionInView.questionId = questionAtIndex.id;
      this.questionInView.questionText = questionAtIndex.text;

      if (this.failedQuizzes.length > 0) {
        let failedQuestion = this.failedQuizzes.find(failedQuestion => failedQuestion.questionID === questionAtIndex.id);
        let failedQuestionIndex = this.failedQuizzes.findIndex(failedQuestion => failedQuestion.questionID === questionAtIndex.id);
        if (failedQuestion) {
          questionToShow.classList.add("failed-color");
          const element = this.renderer.createElement('div');
          element.innerHTML = "<h3>Correct Answer:</h3> " + failedQuestion.correctAnswerText;
          this.renderer.appendChild(questionToShow, element);
          this.failedQuizzes.splice(failedQuestionIndex, 1);
        }

      }
      if (questionItemNavButtons.length > 0) {
        questionItemNavButtons.item(questionIndex).classList.add("questionBadge_active");
      }


    } else {
      //return an empty question
      //hide previous
      //show end
    }

    if (this.assessment.submitted)
      this.showsubmit = false;
  }
  async saveAssessment(isdraft: boolean = false, autosave: boolean = false) {
    //stop the clock
    try {
      this.headerinfo.pageLoadingStarted(this);
      this.submitinProgress = true;

      let questionAnswerString = [];
      let studentQuestionResponse = this.questionPane.nativeElement as HTMLElement;
      let questionAnswerObject;
      //handle multichoice business
      if (this.assessment.questionType == this.assessmentManager.QuestionTypeFlags.multichoiceQuestionFlag) {
        let multichoiceSelectTags = studentQuestionResponse.getElementsByTagName("select");

        // `return` inside a forEach callback only skips that one question — it does not
        // leave saveAssessment. So an unanswered question showed the error below and the
        // assessment was still submitted, silently missing that answer, and the student
        // was marked wrong on it. The flag makes the check actually stop the submission.
        let hasUnansweredQuestion = false;
        Array.from(multichoiceSelectTags).forEach((item) => {
          let optionId = Number.parseInt(item.value);
          let questionId = Number.parseInt(item.getAttribute("id"));
          if (Number.isNaN(questionId) || Number.isNaN(optionId) || item.value == "--Select Answer--") {
            hasUnansweredQuestion = true;
            return;
          }

          questionAnswerString.push({
            optionID: optionId,
            questionID: questionId,
            questiontype: this.assessmentManager.QuestionTypeFlags.multichoiceQuestionFlag,
            assessmentID: this.assessment.id
          });
        });

        if (hasUnansweredQuestion) {
          // one message, however many are unanswered
          this.toastr.error("Please answer every question before submitting.");
          return;
        }
      }

      if (questionAnswerString.length > 0) {
        //this.header.pageLoadingStarted(this);

        let jsonQuestionAnswerString = JSON.stringify(questionAnswerString)

        questionAnswerObject = JSON.parse(jsonQuestionAnswerString);

        let submissionModel = new AssessmentAnswerSubmissionModel();
        submissionModel.questionanswerobject = questionAnswerObject
        submissionModel.isdraft = isdraft;
        submissionModel.moduleID = this.moduleid;

        try {
          const data: any = await this.assessmentManager.submitAssessment(submissionModel).toPromise();

          this.failedQuizzes = data.failedAssessmentQuestions;
          this.isScored = true;
          // this.score = data.message;
          this.assessment.submissionid = data.submissionid;
          if (this.failedQuizzes.length > 0) {
            this.showRetake = true;
            this.failedMessage = this.failedQuizzes.length == this.questionCount ? "You got the answers wrong" : "You got some of the answers wrong";
            this.getQuestionToShow(0);
          } else {
            this.showInclassAssessement = false;
            this.quizCompleted = true;
            this.headerinfo.pageLoadingDone(this);
            this.markCompletedclicked();
          }
        }
        catch (error) {
          console.error(error);

          this.toastr.error('An error occured');
        }




      }
    }
    finally {
      this.headerinfo.pageLoadingDone(this);
      this.submitinProgress = false;
    }
  }

  retakeAssessment() {
    this.headerinfo.pageLoadingStarted(this);
    try {
      this.assessmentManager.deleteSubmittedAssessmentByStudent(this.assessment.id, this.assessment.submissionid, this.classid).subscribe(
        (data: any) => {
          this.isScored = false;
          this.failedMessage = '';
          this.startQuiz();
        },
        (error: any) => {
          console.error(error);
          this.toastr.error('An error occured');
        },
        () => {
          this.headerinfo.pageLoadingDone(this);
        }
      )
    } catch (error) {
      console.error(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }

  }

  clearQuiz() {
    this.showInclassAssessement = false;
    this.assessment = null;
    this.questions = [];
  }

  showTextReady(){        
    if(this.textToRead){
      const doc = new DOMParser().parseFromString(this.textToRead, 'text/html');
      this.hasMedia = doc.querySelector('video, audio, iframe, img, embed') !== null;
      let decodedtxt = (HTMLEntities.cleanuphtml(this.textToRead)).replace(/\s/g, '');      
      this.textReaderReady = decodedtxt?.length > 1;
    }
  }
}
